import React from "react";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

import ImageCropUpload from "../generic/ImageCropUpload";

// Foto de perfil del aspirante. Es una capa fina sobre ImageCropUpload, que es
// donde vive el recorte: lo único propio de esta pantalla es que la foto va
// cuadrada, redonda y a 512 px.
//
// El archivo recortado se le entrega al padre y sube por intakeApplicant con el
// resto del perfil — las páginas públicas no tienen sesión de Firebase Auth, así
// que nunca pasa por el SDK de Storage.

export default function ApplicantPhotoUpload({
  currentUrl,
  alt = "",
  disabled = false,
  onChange,
  onRemove,
}) {
  return (
    <ImageCropUpload
      currentUrl={currentUrl}
      alt={alt}
      disabled={disabled}
      aspect={1}
      shape="circle"
      outputWidth={512}
      outputName="photo.jpg"
      label="Foto de perfil"
      dialogTitle="Ajusta tu foto"
      confirmLabel="Usar esta foto"
      removeLabel="Quitar foto"
      changeAriaLabel="Cambiar foto de perfil"
      emptyIcon={<PersonOutlineIcon sx={{ fontSize: "3rem" }} />}
      onChange={onChange}
      onRemove={onRemove}
    />
  );
}
